import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux'
import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField'

import classnames from 'classnames'

import { withSnackbar } from 'notistack';

import { verfiySource, getUserInfo } from '../../store/actions/accountActions'
import { ACHDiscountWrapper } from '../shared/genericFunctions'

const styles = (theme) => ({
    error: {
        color: 'indianred'
    },
    link: {
        color: theme.palette.primary.main + ' !important',
        cursor: 'pointer'
    },
    marginTop1: {
        marginTop: theme.spacing(1)
    },
    marginTop2: {
        marginTop: theme.spacing(2)
    },
    bgTransparent: {
        background: 'transparent'
    },
    bgWhite: {
        background: 'white'
    },
    borderEnabled: {
        border: '1px solid #161717'
    },
})

const VerifyAmountForm = ({ customerId, source, classes, cards, cardDefault, enqueueSnackbar }) => {
    const [clicked, setClicked] = useState(false);
    const [amt1, setAmt1] = useState()
    const [amt2, setAmt2] = useState()
    const currentUser = useSelector(state => state.authentication.currentUser)
    const dispatch = useDispatch()
    const [mandErr, setMandErr] = useState(false)
    const [verificationError, setVerificationError] = useState(false)
    const [errMsg, setErrMsg] = useState('')

    useEffect(() => {
        if (amt1 && amt2) {
            setMandErr(false)
        }
    }, [amt1, amt2])


    const onAmt1Change = (e) => {
        setAmt1(e.target.value)
    }
    const onAmt2Change = (e) => {
        setAmt2(e.target.value)
    }
    /*const handleConsent = (e) => {
        setConsent(e.target.checked)
        if (e.target.checked) {
            setConsentErr(false)
        }
    }*/

    const handleSubmit = async event => {
        event.preventDefault();


        // To prevent double clicks
        if (clicked) {
            return;
        }

        if (!amt1 || !amt2 || amt1 === '' || amt2 === '') {
            setMandErr(true)
            return;
        }


        dispatch(verfiySource(customerId, source, amt1, amt2, (err, payload) => {
            if (err) {
                setVerificationError(true)
                setClicked(false)
                console.log(payload)
                if (payload && payload.data && payload.data.message) {
                    setErrMsg(payload.data.message.message)
                }

            } else {
                // dispatch ! 
                dispatch(getUserInfo(currentUser.userId, (err, accountInfo) => {
                    enqueueSnackbar('Verification successful', { variant: 'success' });
                    //TO-DO: After verification - check if default source is bank acct & check if the discount was already applied ; if not add the discount
                    ACHDiscountWrapper(accountInfo, 'apply', currentUser, dispatch)
                }))

            }
        }))

        /*  enqueueSnackbar(result.error.message, { variant: 'error', persist: 'false' });
  
          setClicked(true)
          if (err) {
              enqueueSnackbar(err, { variant: 'error', persist: 'true' });
              setClicked(false);
          }*/

    };

    return (
        <form onSubmit={handleSubmit} noValidate autoComplete="off">

            <Grid container spacing={3} alignItems="center">
                <Grid item xs>
                    <Paper style={{ padding: '12px' }}>
                        <Grid container>
                            <Paper style={{ background: '#b8e3f9', padding: '12px' }}>
                                To verify, we have issued 2 micro deposits to your bank account. These take 1-2 business days to appear on your online statement.
                                The statement has a description that include AMTS followed by two microdeposits. Please enter those amounts below and click verify.

                            </Paper>
                        </Grid>
                        <Grid container alignItems="center" className={classes.marginTop2}>
                            <Grid item xs={12} sm={3}><Paper className={classes.bgTransparent}>Amount 1</Paper></Grid>
                            <Grid item xs sm={3}><Paper className={classnames(classes.bgWhite, classes.borderEnabled)}>
                                <TextField InputProps={{ disableUnderline: true, startAdornment: (<div>$.</div>), endAdornment: (<div>USD</div>) }} fullWidth placeholder={'08'} value={amt1} onChange={onAmt1Change} /></Paper></Grid>
                        </Grid>

                        <Grid container className={classes.marginTop1} alignItems="center">
                            <Grid item xs={12} sm={3}><Paper className={classes.bgTransparent}>Amount 2</Paper></Grid>
                            <Grid item xs sm={3}><Paper className={classnames(classes.bgWhite, classes.borderEnabled)}><TextField InputProps={{ disableUnderline: true, startAdornment: (<div>$.</div>), endAdornment: (<div>USD</div>) }} fullWidth placeholder={'45'} value={amt2} onChange={onAmt2Change} /></Paper></Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>

            <Grid container spacing={3} style={{ paddingLeft: '24px' }} item>

                {mandErr && <Grid item style={{ color: 'indianred' }}>
                    Please enter both the fields to verify
                </Grid>}
                {verificationError && <Grid item style={{ color: 'indianred' }}>
                    {errMsg}
                </Grid>}

            </Grid>
            <Grid container spacing={3} alignItems="center">

                <Grid container item xs justify="flex-end">

                    <Button type="submit" disabled={clicked} variant="contained" size="large" name="MakePaymentBtn" color="primary" >
                        Verify
                    </Button>
                </Grid>

            </Grid>

        </form>
    );
};

export default withStyles(styles)(withSnackbar(VerifyAmountForm));
